@if (!readonly) {
  <input
    type="text"
    mwlFlatpickr
    placeholder="Bitte wählen"
    [options]="DateRangeOptions"
    [formControl]="setDateFormControl"
    [ngClass]="{ clearable: clearable && !isEmpty }"
    (flatpickrOpen)="(onOpen)"
    (flatpickrClose)="onClose($event)" />
  @if (clearable && !isEmpty) {
    <span
      class="date-clear-wrapper"
      title="Clear all"
      (click)="clearInput()">
      <span class="date-clear">×</span>
    </span>
  }
} @else {
  <div class="text-like-form">
    {{ setDateFormControl.value | dateRange: "shortDate" }}
  </div>
}
